import React from 'react';
import f from './Filters.module.css';

const money = (value) => {
  const number = Number(value || 0);
  return `${number < 0 ? '-' : ''}$${Math.abs(number).toFixed(2)}`;
};

/* Avisos sobre lo que el servidor realmente aplicó (`scope` de /dashboard-metrics/resolve).
   Ninguno inventa cifras: solo explican por qué una selección da menos de lo esperado o qué queda fuera. */
export const buildScopeNotices = (scope) => {
  if (!scope) return [];
  const notices = [];
  const branches = scope.branches || {};
  const events = scope.events || {};

  if (branches.kind === 'empty') {
    notices.push({ id: 'empty', text: 'La selección no incluye ninguna sucursal con datos (grupos inactivos o sin sucursales disponibles), por eso no hay cifras.' });
  }
  if ((branches.ignored_groups || []).length > 0) {
    notices.push({ id: 'ignored-groups', text: `Se omitieron grupos inactivos: ${branches.ignored_groups.map((group) => group.name).join(', ')}.` });
  }
  if (branches.narrowed) {
    notices.push({ id: 'narrowed', text: 'Algunas sucursales de la selección no están dentro de tus permisos y no se incluyeron.' });
  }
  if ((events.ignored || []).length > 0) {
    notices.push({ id: 'ignored-events', text: `Se omitieron ${events.ignored.length} ${events.ignored.length === 1 ? 'evento que ya no está disponible' : 'eventos que ya no están disponibles'}. Si ninguno está disponible, no hay cifras.` });
  }
  if (scope.unattributed_refunds && scope.unattributed_refunds.count > 0) {
    const { count, total } = scope.unattributed_refunds;
    notices.push({
      id: 'refunds',
      kind: 'warn',
      text: `Hay ${count} ${count === 1 ? 'devolución' : 'devoluciones'} sin evento (${money(total)}) en las sucursales y fechas seleccionadas. `
        + 'Cada devolución cuenta en el evento de su venta original; estas no tienen evento (su venta no era de un evento o no se pudo determinar), por eso no se descuentan de las ventas del evento.',
    });
  }
  return notices;
};

export default function ScopeNotices({ scope }) {
  const notices = buildScopeNotices(scope);
  if (notices.length === 0) return null;

  return (
    <div data-testid="scope-notices">
      {notices.map((notice) => (
        <div key={notice.id} className={`${notice.kind === 'warn' ? f.warn : f.infoNotice}`} role="status" data-testid={`scope-notice-${notice.id}`} style={{ marginBottom: 8 }}>
          {notice.text}
        </div>
      ))}
    </div>
  );
}
